// extracted by mini-css-extract-plugin
module.exports = {"tagsTab":"TagsTab_tagsTab__1ZzFN","errorView":"TagsTab_errorView__3UMgD"};